import React from 'react';

import lifeSaver from '../../../assets/life_saver.svg';

export function LifeSaver() {
  return (
    <div className="life-saver" style={{ display: 'flex', height: '100%' }}>
      <img src={lifeSaver} alt="Life Saver" className="after" />
    </div>
  );
}
